const isShopAtStore = {
    computed: {
        isShopAtStore() {
            // if (this.info) {
            //     if (this.info.onlineCategoryL1En) {
            //         if (
            //             this.info.onlineCategoryL1En ===
            //             "Beer Wine & Spirits"
            //         ) {
            //             return true;
            //         }
            //     }
            // }
            return false;
        },
    },
};

export default isShopAtStore;